<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Reconciliation Reports",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
  },
  data() {
    return {
      title: "Stock Reconciliation Reports",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Reconciliation Reports",
          active: true,
        },
      ],
      totalRows: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsReconciliationReportServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      reconciliationColumns: [
      {
        key: "sn",
        label: "S/N",
        formatter: (_, __, idx) => this.ReconciliationPagination.from + idx,
      },
      {
        key: "efrisstatus",
        label: "STATUS",
      },
      {
        key: "branch",
        label: "BRANCH",
      },
      {
        key: "date",
        label: "DATE PERFORMED",
      },
      {
        key: "user",
        label: "PERFORMED BY",
      },
      {
        key: "type",
        label: "CATEGORY",
      },
      {
        key: "num_field",
        label: "PRODUCTS AFFECTED",
      },
      {
        key: "actions",
        label: "ACTIONS",
        tdClass: "text-nowrap",
      },
      ],

      modal_id:'',

      filterProducts:{
        product: '',
        branch_id:0,
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        category:'',
      },

      data:{
        id:'',
        filterdata:{
          product: '',
          branch_id:0,
          datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
          dateto: moment(new Date()).format("YYYY-MM-DD"),
        },
      }
    };
  },

  computed: {
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("stock", ["ReconciliationReport","SaveStatus","ReconciliationReportPagination","ReconciliationReportPaginated"]),
    ...mapGetters("auth", ["branchid","Branches"]),
    ...mapGetters("setting", ["BusinessSettings"]),
    
  rows() {
      return this.IsReconciliationReportServerPaginated
        ? this.ReconciliationReportPagination?.total
        : this.ReconciliationReport
        ? this.ReconciliationReport.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsReconciliationReportServerPaginated) {
          return (
            this.ReconciliationReportPagination?.per_page ||
            this.filterProducts.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsReconciliationReportServerPaginated) {
          this.filterProducts.per_page = value;
          this.filterProducts.page = 1;
          this.FetchReports(this.filterProducts);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.ReconciliationReportPaginated && this.ReconciliationReportPagination
          ? this.ReconciliationReportPagination.current_page
          : 1;
      },
      set(value) {
        if (this.ReconciliationReportPaginated) {
          this.filterProducts.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    }
  },

  methods: {
    ...mapActions({
      FetchReports: "stock/fetchReconciliationReport",
      FetchBranches: "auth/fetchBranches",
      SynchronizeData: "stock/SynchronizeReconciliation",
      FetchBusinessSettings: "setting/fetchBusinessSettings",
    }),

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    redirect(value) {
      this.$router.push(
        `/reconciliation/details/${btoa(value)}`
      );
    },
    FilterReport(){      
      this.FetchReports(this.filterProducts);
    },

    showSynchronizeModal(id){  
      this.data.filterdata = this.filterProducts;    
      this.data.id = id;
    },

    Synchronize(modalId){
      this.modal_id = modalId;
      this.SynchronizeData(this.data)
    },
      handlePageChange(newPage) {
      if (this.IsReconciliationReportServerPaginated) {
        let payload = {
          ...this.data,
          page: newPage,
          per_page: this.serverPerPage,
        };
        this.FetchReports(payload);
      }
    },
  },

  created() {
    this.FetchReports(this.filterProducts);
    this.FetchBranches();
    this.FetchBusinessSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
               <div class="col-md-3 mb-2" v-if="BusinessSettings && (BusinessSettings.store == 1 || BusinessSettings.consumables == 1)">
                <label>FILTER BY CATEGORY</label>
                <select v-model="filterProducts.category" @change="FilterReport()" class="form-control">
                  <option value="">All Categories</option>
                  <option value="0">Shop</option>
                  <option value="1" v-if="BusinessSettings.store == 1">Store</option>
                  <option value="2" v-if="BusinessSettings.consumables == 1">Consumables</option>
                </select>
              </div>
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-2" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>                
                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="filterProducts.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="FilterReport()"
                >
                </model-list-select>
              </div>
            </div>
            
            <div class="row py-4">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->              
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="filterProducts.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="filterProducts.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-4 form-group">
                Search Product
                <div class="input-group">
                <input
                  v-model="filterProducts.product"
                  type="text"
                  class="form-control"
                  placeholder="Enter product name or code"
                  @keyup.enter="FilterReport()"
                /> 
                <div class="input-group-append">
                  <button class="btn btn-primary" type="button" @click="FilterReport()">
                    
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                  ></b-spinner>

                  <span>Search</span>                  
                  </button>
                </div>
                
              </div>              
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="reconciliationColumns"
                :rows="ReconciliationReport ? ReconciliationReport : []"
                :total-rows="rows"
                :pagination="ReconciliationReportPagination"
                :server-pagination="IsReconciliationReportServerPaginated"
                :loading="SaveStatus"
                row-class="reconciliation-bordered"
              >
                <!-- S/N -->
                <template #cell(sn)="{ index }">
                  {{ ReconciliationReportPagination.from + index }}
                </template>

                <!-- STATUS -->
                <template #cell(efrisstatus)="{ row }">
                  <button
                    class="btn btn-info btn-sm"
                    v-b-modal.synchronize-modal
                    @click="showSynchronizeModal(row.id)"
                    v-if="row.efrisstatus == 0"
                  >
                    Synchronize
                  </button>
                  <button class="btn btn-sm" disabled v-else>
                    <h6>Synchronized</h6>
                  </button>
                </template>

                <!-- BRANCH -->
                <template #cell(branch)="{ value }">
                  {{ value }}
                </template>

                <!-- DATE PERFORMED -->
                <template #cell(date)="{ value }">
                  {{ value }}
                </template>

                <!-- PERFORMED BY -->
                <template #cell(user)="{ value }">
                  {{ value }}
                </template>

                <!-- CATEGORY -->
                <template #cell(type)="{ value }">
                  {{ value }}
                </template>

                <!-- PRODUCTS AFFECTED -->
                <template #cell(num_field)="{ row }">
                  <strong>{{ row.products }}</strong> products
                </template>

                <!-- ACTIONS -->
                <template #cell(actions)="{ row }">
                  <button class="btn btn-primary btn-sm" @click="redirect(row.id)">
                  <i class="fa fa-eye text-light"></i> Details
                  </button>
                </template>
              </DataTable>
            </div>
            <!-- resynchronise mode starts -->
            <b-modal
              header-bg-variant="info"
              header-text-variant="light"
              body-text-variant="info"
              footer-bg-variant="info"
              footer-text-variant="info"
              id="synchronize-modal"
              hide-footer
            >
              <template #modal-title> Synchronize this reconciliation</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    You are submitting this reconciliation to Efris? Click Proceed Button to Submit.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('synchronize-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="Synchronize('synchronize-modal')"
                >
                  <i class="fa fa-check"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Submitting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- resynchronise mode ends -->
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
